import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ActionsShareUrl, {shareUrlButtonTypes} from '@adv-mt/mt-actions-share-url'

import FavoriteButton from './FavoriteButton.js'

const ActionButtons = ({dealer, isShareDealerEnabled, hideText = false, className = '', isFavorite = false}) => {
  const {i18n, domain} = useContext(Context)
  const {culture} = i18n
  const config = domain.get('config')

  const {AUTHENTICATION_HIT_INFORMATIONS_2} = config.get('tracking')

  const {
    TRACKING_EVENT_NAMES: {DEALER_STOCK_SHARED, DEALER_STOCK_SHARED_CLICKED},
    TRACKING_TRANSLATIONS_BY_CULTURE
  } = config.get('tracking')
  const {PROFESSIONAL_STOCK_PAGE_NAME} = TRACKING_TRANSLATIONS_BY_CULTURE[culture]

  const shareDealerActionClass = cx(className, {
    'is-hidden': isShareDealerEnabled
  })
  const secondaryActionClass = cx(className, 'is-hidden')

  return (
    <>
      {dealer.isActive && (
        <FavoriteButton
          dealer={dealer}
          isFavorite={isFavorite}
          label={!hideText && i18n.t('COMMON.FAVORITE')}
          className={secondaryActionClass}
          isFitted
          trackingExtraData={{hit_origin: 'dealer stock page'}}
          authenticationHitInformation2={AUTHENTICATION_HIT_INFORMATIONS_2.DEALER_STOCK_PAGE}
        />
      )}
      {isShareDealerEnabled && (
        <ActionsShareUrl
          type={hideText ? shareUrlButtonTypes.ICON_BUTTON_OUTLINE : shareUrlButtonTypes.INLINE_BUTTON_OUTLINE}
          trackingOrigin={PROFESSIONAL_STOCK_PAGE_NAME}
          trackingSharedEventName={DEALER_STOCK_SHARED}
          trackingClickEventName={DEALER_STOCK_SHARED_CLICKED}
          trackingContext={dealer}
          size="medium"
          className={shareDealerActionClass}
        />
      )}
    </>
  )
}

ActionButtons.propTypes = {
  dealer: PropTypes.object,
  isShareDealerEnabled: PropTypes.bool,
  hideText: PropTypes.bool,
  className: PropTypes.string,
  isFavorite: PropTypes.bool
}

export default ActionButtons
